import { useEffect, useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
    document.title = "Unauthorized | Mowing";
    
    return (
        <div className="container-fluid">
            <div className="text-center">
                <h2 className='text-danger pt-3'>You are not authorized to view this page.</h2>
            </div>
        </div>
    );
}
 
export default Unauthorized;